// Batch processing configuration
export const BATCH_SIZE = 1000 // API limit
export const EXCEL_WRITE_CHUNK_SIZE = 500 // Rows to write at once to Excel
export const CONCURRENT_REQUESTS = 2 // Number of parallel API requests
export const FORMULA_DEBOUNCE_MS = 150 // Debounce window for collecting formula requests

// Pending formula request structure
export interface PendingFormulaRequest {
    formula: string
    addressToUse: string
    formulaIndex: number
    worksheetId: string
    type: 'WISE' | 'WISEPRICE'
    isRefresh?: boolean // If true, use full column scan for refresh
}

// Shared progress state for unified loading UI across multiple formulas
export interface SharedProgressState {
    totalTickers: number
    completedTickers: number
    totalFormulas: number
    completedFormulas: number
}

export interface BatchProgress {
    currentBatch: number
    totalBatches: number
    processedTickers: number
}

export type ProgressCallback = (progress: BatchProgress) => void

// Callback for when a batch starts - allows writing Loading... placeholders
export type BatchStartCallback = (
    batchIndex: number,
    startIndex: number,
    endIndex: number
) => Promise<void>

// Callback for when a batch completes - allows progressive writing
export type BatchCompleteCallback<R> = (
    result: R,
    batchIndex: number,
    startIndex: number,
    endIndex: number
) => Promise<void>

export interface WiseFormulaInfo {
    worksheetId: string
    formulaAddress: string
    firstParam: string
    secondParam: string
    thirdParam: string
    fourthParam?: string
    fifthParam?: string
    column?: string // Column where the formula is located (e.g., "B")
    dataRange?: string // Range of data cells filled (e.g., "B3:B102")
}
